import React from 'react';
import Icon from '../../../components/AppIcon';
import StatusBadge from './StatusBadge';
import Button from '../../../components/ui/Button';

const OrderCard = ({ order, onView, onEdit, onUpdateStatus }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR'
    })?.format(amount);
  };

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-1 hover:shadow-elevation-3 transition-smooth p-4 md:p-6 border border-border">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-base md:text-lg font-semibold text-foreground truncate">
              {order?.customer}
            </h3>
            <StatusBadge status={order?.status} />
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <Icon name="FileText" size={16} />
              Folio: {order?.folio}
            </span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1">
              <Icon name="Calendar" size={16} />
              {formatDate(order?.date)}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => onView(order)}
            iconName="Eye"
            iconPosition="left"
          >
            Ver
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onEdit(order)}
            iconName="Edit"
            iconPosition="left"
          >
            Editar
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Car" size={20} color="var(--color-primary)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground">Vehículo</p>
            <p className="text-sm font-medium text-foreground truncate">
              {order?.vehicle}
            </p>
            <p className="text-xs text-muted-foreground">{order?.plates}</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={20} color="var(--color-accent)" />
          </div>
          <div className="min-w-0">
            <p className="text-xs text-muted-foreground">Técnico</p>
            <p className="text-sm font-medium text-foreground truncate">
              {order?.technician}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Icon name="Package" size={16} color="var(--color-muted-foreground)" />
          <span className="text-sm text-muted-foreground">
            {order?.itemCount} {order?.itemCount === 1 ? 'artículo' : 'artículos'}
          </span>
        </div>
        <div className="text-right">
          <p className="text-xs text-muted-foreground mb-1">Total</p>
          <p className="text-lg md:text-xl font-bold text-foreground">
            {formatCurrency(order?.total)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;